module.exports = __webpack_public_path__ + "static/media/hair (31).768ec2de.jpg";